<template>
  <div class="wrapper">
 

    <div class="main-panel center-panel">
     
        <login-form></login-form>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>

import LoginForm from "@/pages/LoginForm.vue";

export default {
  components: {
      LoginForm
  }
};
</script>
